module.exports = __webpack_public_path__ + "img/satomin.134740de.png";